// components
import { Group } from '@mui/icons-material';
import Iconify from '../../components/iconify';

// ----------------------------------------------------------------------

const ICONS = {
  user: <Group />,
  branch: <Iconify icon={'mdi:company'} />,
  department: <Iconify icon={'mdi:location'} />,
  system: <Iconify icon={'tdesign:system-code'} />

};

// ----------------------------------------------------------------------

export function useNavData() {

  const data = [
    // ADMINISTRADOR
    // ----------------------------------------------------------------------
    {
      subheader: 'Administrador',
      items: [
        {
          title: 'Usuários',
          path: '/users',
          icon: ICONS.user,
        },
        {
          title: 'Filiais',
          path: '/branches',
          icon: ICONS.branch
        },
        {
          title: 'Departamentos',
          path: '/departments',
          icon: ICONS.department
        },
        {
          title: 'Sistemas',
          path: '/systems',
          icon: ICONS.system
        }
      ],
    },    
  ];

  return data;
}
